<template>
  <div class="steppers">
    <div
      v-for="(step, index) in steps"
      :key="`step-${index}`"
      class="steppers-step"
      @click="onSelectStep(index + 1)"
    >
      <!-- there are three possible steps: current, prev, or next -->
      <div class="steppers-step-content" :data-tooltip="tooltipData[index]" :ref="`step${index}`">
        <span
          v-if="!current || isNextStepPassed || isLastStepCompleted"
          class="steppers-step-content-prev"
        >
          <VSvgIcon name="check" />
        </span>
        <span v-else-if="index + 1 < current" class="steppers-step-content-prev">
          <VSvgIcon name="check" />
        </span>
        <span v-else-if="isLastStepCompleted" class="steppers-step-content-prev">
          <VSvgIcon name="check" />
        </span>
        <span v-else-if="index + 1 === current" class="steppers-step-content-current"
          >{{ index + 1 }}
        </span>
        <span v-else class="steppers-step-content-next">
          {{ index + 1 }}
        </span>
      </div>
      <!-- step to step progress line -->
      <div v-if="index !== steps - 1" class="steppers-step-progress">
        <span
          v-if="index + 1 < current || !current || isNextStepPassed"
          class="steppers-step-progress-line"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';

export default {
  name: 'Stepper',
  components: { VSvgIcon },
  props: {
    steps: Number,
    current: Number,
    onSelectStep: Function,
    tooltipData: Array,
    isNextStepPassed: Boolean,
    isLastStepCompleted: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    handleEdgeTooltip() {
      const stepElements = this.$refs;
      Object.values(stepElements).forEach(el => {
        const element = el[0];
        const parentWidth = element.offsetParent.clientWidth;
        const stepWidth = element.clientWidth;
        const offsetFromLeft = element.offsetLeft;
        const leftMost = offsetFromLeft < stepWidth;
        const rightMost = parentWidth - (offsetFromLeft + stepWidth) < stepWidth * 1.5;
        leftMost && element.classList.add('left');
        rightMost && element.classList.add('right');
      });
    },
  },
  created() {
    window.addEventListener('resize', this.handleEdgeTooltip);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleEdgeTooltip);
  },
};
</script>
